import axios from "@/plugins/Axios";

const model = "plans";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

export { all };
